import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { ManagementDataService } from './management-data.service';

@Injectable({
  providedIn: 'root'
})
export class ModulesServiceService {

  dataServ = inject(ManagementDataService);
  activeModules:WritableSignal<any> = signal<any>(null);

  constructor() {
    this.getAllModules();
  }

  setActiveModules(modules:any){
    this.activeModules.set(modules);
  }

  getActiveModules(){
    return this.activeModules();
  }

  async getAllModules(){
    await this.dataServ.request('segment','').subscribe((env_data:any)=>{
      let available_modules = env_data.data.attributes;
      this.setActiveModules(available_modules);
    });
  }
  
}
